// src/components/DashboardSettings.js — Settings → Dashboard: who sees which dashboard sections and the sign-in pop-up
// [marker: dashboard v1]
import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

const LABELS = {
  tasks: { name: 'My tasks', hint: 'new, overdue and due-today tasks' },
  events: { name: 'Upcoming events', hint: 'tickets, new vs. returning buyers, email checklist' },
  renewals: { name: 'Renewals & membership reminders', hint: 'days left until renewals, members past due' },
  receivables: { name: 'Money to collect', hint: 'overdue invoices and dues, with reminder emails' },
};

export default function DashboardSettings() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(null);
  const load = () => api.get('/dashboard/settings').then(r => setData(r.data)).catch(err => toast.error(err.response?.data?.error || 'Could not load.'));
  useEffect(() => { load(); }, []);
  if (!data) return <div className="spinner" />;

  const save = async (s, patch) => {
    const next = { sections: s.sections, popup: s.popup, ...patch };
    setSaving(s.id);
    setData(d => ({ ...d, staff: d.staff.map(x => (x.id === s.id ? { ...x, ...next } : x)) }));
    try { await api.put(`/dashboard/settings/${s.id}`, next); }
    catch (err) { toast.error(err.response?.data?.error || 'Could not save.'); load(); }
    finally { setSaving(null); }
  };
  const toggle = (s, sec) => save(s, { sections: s.sections.includes(sec) ? s.sections.filter(x => x !== sec) : [...s.sections, sec] });

  return (
    <div className="card">
      <div className="card-header"><span className="card-title">Dashboard — who sees what</span></div>
      <div className="card-body">
        <p style={{ marginTop: 0, fontSize: '0.875rem', color: 'var(--gray-600)' }}>
          Choose which parts of the dashboard each person sees, and whether “Your day at a glance” pops up when they sign in.
          Changes save as you click. (Sending reminder emails also needs a manager or admin role.)
        </p>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Staff member</th>
                {data.sections.map(sec => <th key={sec} style={{ textAlign: 'center' }} title={LABELS[sec]?.hint}>{LABELS[sec]?.name || sec}</th>)}
                <th style={{ textAlign: 'center' }}>Pop-up at sign-in</th>
              </tr>
            </thead>
            <tbody>
              {data.staff.map(s => (
                <tr key={s.id} style={{ opacity: s.is_active ? 1 : 0.5 }}>
                  <td>
                    <div style={{ fontWeight: 600 }}>{s.first_name} {s.last_name}</div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--gray-500)' }}>{s.email} · {String(s.role || '').replace('_', ' ')}{s.is_active ? '' : ' · inactive'}</div>
                  </td>
                  {data.sections.map(sec => (
                    <td key={sec} style={{ textAlign: 'center' }}>
                      <input type="checkbox" checked={s.sections.includes(sec)} disabled={saving === s.id} onChange={() => toggle(s, sec)} />
                    </td>
                  ))}
                  <td style={{ textAlign: 'center' }}>
                    <input type="checkbox" checked={!!s.popup} disabled={saving === s.id} onChange={() => save(s, { popup: !s.popup })} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
